<div class="flex header-container" [style.min-height]="minHeight" [class.p-top]="soAndAoCollapse">
  @if (!hideArrow) {
    <div class="flex">
      <app-st-icon [ngClass]="{'rotate': panelActive}" class="ant-collapse-arrow" name="keyboard_arrow_right"></app-st-icon>
    </div>
  }
  @if (!onlyText) {
    <div>
  <!--    <label class="text-label-12 text-semibold">{{code}}</label>-->
      <div class="flex-center-between gap-200 core">
        <h3 (click)="navigationEvent.emit(); $event.stopPropagation()" [style.font-size]="titleFontSize"
           class="text-header-16 text-nowrap transition-02">{{name}}</h3>
        @if (showStateBadge) {
          @if (state | projectState; as stateData) {
             <span class="st-badget"
                   [ngClass]="[ stateData.class, ((isMobile$ | async) ? 'small' : '') ]">
             <app-st-icon [bold]="true" [name]="stateData.icon"></app-st-icon>
             <label>{{ stateData.name }}</label>
            </span>
          }
        }


  <!--      <div *ngIf="date" class="flex-center gap-075 color-grey-9">-->
  <!--        <app-st-icon [bold]="true" name="calendar_today"></app-st-icon>-->
  <!--        <span class="text-label-14 text-nowrap">{{date | date:'d MMM' | uppercase}}</span>-->
  <!--      </div>-->

        <app-action-btns
          [copy]="actions.copy"
          [file]="actions.file"
          [message]="actions.message"
          [drawer]="actions.drawer"
          [select]="actions.select"
          [selectList]="selectList"
          (buttonClick)="onAction($event)"
        ></app-action-btns>
      </div>
    </div>
  }
  @if (onlyText) {
    <strong [class.lh-2]="soAndAoCollapse">
      @if (isWarning) {
        <app-st-icon [name]="'warning'" [bold]="true" [color]="'#FF990A'" [filled]="true"></app-st-icon>
      }
      {{onlyText}}
    </strong>
  }

  @if (soAndAoCollapse && soAndAoCollapse.length === 0) {
    <div class="st-badget subtle-amber">
      <app-st-icon [bold]="true" [name]="'error'"></app-st-icon>
      <label>No hay {{isIngreso ? 'Ingresos' : 'Gastos'}} en esta Orden de servicio</label>
    </div>
  }

</div>
